
import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEye, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import { Link } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import { toast } from "react-toastify";

const HomerBannerList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [list, setList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  // Initial Fetch
  useEffect(() => {
    callAPI("get", apiRoutes.admin.homeBanner, "");
  }, []);

  // Update list when response changes
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      setList(responce.data);
    }
  }, [responce, statusCode]);

  // Handle delete
  const deleteRecord = (id) => {
    setIsDelete(false);
    callAPI("delete", `${apiRoutes.admin.homeBanner}/${id}`, "");
  };

  // Show toast and re-fetch after delete
 useEffect(() => {
  if (statusCode === 204 && !isDelete) {
    toast.success("Home Banner deleted successfully!");
    
    setTimeout(() => {
      callAPI("get", apiRoutes.admin.homeBanner, ""); // Refresh list after 1 sec
    }, 1000);

    setIsDelete(true);
  }
}, [statusCode, isDelete, callAPI]);


  // Filtered data for search
  const filteredData = list.filter(
    (item) =>
      item.title1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Testimonial List"
            subTitle="Manage all registered Testimonial."
          />
          <Link to="/add-homebanner"><button className="btn">Add Home Banner</button></Link>
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <h5 className="mb-0 fw-semibold">Banner List</h5>
                </div>
                <div className="col-12 col-md-5"></div>
                <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-start">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by Banner Heading or Detail"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Image</th>
                    <th className="px-4 py-2">Banner Heading</th>
                    <th className="px-4 py-2">Banner Detail</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 ? (
                    filteredData.map((li, index) => (
                      <tr key={li.id} className="sys-list-table__row border-bottom">
                        <th className="px-4 py-2">{index + 1}</th>
                        <td className="px-4 py-2">
                          <div className="d-flex align-items-center">
                            <img
                              src={li.image_url}
                              alt={`${li.title1}'s image`}
                              className="rounded-circle me-3"
                              style={{
                                width: "36px",
                                height: "36px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </td>
                        <td className="px-4 py-2">{li.title1}</td>
                        <td className="px-4 py-2">{li.description}</td>
                        <td className="px-4 py-2 text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <Link
                              to={uiRoutes.admin.homeBanner.edit.replace(":id", li.id)}
                            >
                              <button
                                className="sys-list-table__action edit"
                                title="Edit Banner"
                              >
                                <FaEdit />
                              </button>
                            </Link>
                            <button
                              className="sys-list-table__action delete"
                              title="Delete Banner"
                              onClick={() => deleteRecord(li.id)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        No banners found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default HomerBannerList;

